"use strict";

/*
 * Component that receive a prompt and a button. When button is pressed, prompt is shown.
 * This component handles Prompt"s visibility.
 * The second child must be a component that handles an onClick prop. So, it can be just a
 * <button> (because it already handle onClick natively) or another component that receive this.props.onClick
 * and pass it to a component that handles it.
 *
 * # Example of usage:
 *
 * <PromptConfirmButtonGroup>
 *   <Prompt text="Deseja excluir este objeto?" buttonText="Excluir"
 *           buttonClasses="btn btn-danger" type="confirm" onConfirm={this.onConfirm} />
 *   <button title="Remover"></button>
 * </PromptConfirmButtonGroup>
 *
 * <PromptConfirmButtonGroup>
 *   <Prompt text="Deseja excluir este objeto?" buttonText="Excluir"
 *           buttonClasses="btn btn-danger" type="confirm" onConfirm={this.onConfirm} />
 *   <CustomButton></CustomButton>
 * </PromptConfirmButtonGroup>
 * Note: CustomButton must be prepared to receive an onClick prop and handle it.
 *
 */

var PromptConfirmButtonGroup = React.createClass({
  propTypes: {
    children: function(props, propName) {
      var childrenValue = props[propName];
      if (childrenValue == null) {
        return new Error("Warning: Required prop `children` must not be null!");
      } else if (childrenValue.length != 2) {
        return new Error("Warning: Required prop `children` must have 2 elements!");
      }
    },
    className: React.PropTypes.string,
    showPromptAction: React.PropTypes.func,
    closePromptAction: React.PropTypes.func
  },
  getInitialState: function () {
    return {
      showPrompt: false
    };
  },
  hidePrompt: function () {
    if (this.props.closePromptAction) {
      this.props.closePromptAction();
    }
   
    this.setState({
      showPrompt: false
    });
  },
  showPrompt: function(){
    if (this.props.showPromptAction) {
      this.props.showPromptAction();
    }

    this.setState({
      showPrompt: true
    });
  },
  getPrompt: function () {
    if (!this.props.children || !this.props.children[0]) {
      return null;
    }

    var prompt = this.props.children[0];
    var extraProps = {
      onClose: this.hidePrompt,
      isOpen: this.state.showPrompt
    };
    return React.cloneElement(prompt, extraProps);
  },
  getButton: function () {
    if (!this.props.children || !this.props.children[1]) {
     return null;
    }

    var button = this.props.children[1];
    var extraProps = {
      onClick: this.showPrompt
    };
    return React.cloneElement(button, extraProps);
  },
  render: function () {
    return (
      <div className={this.props.className}>
        {
          this.state.showPrompt
          ? this.getPrompt()
          : null
        }
        {this.getButton()}
      </div>
    );
  }
});

module.exports = PromptConfirmButtonGroup;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt-confirm-button-group.jsx